import ActiveIcon from '@/assets/icons/active-icon.svg?react';
import DisactiveIcon from '@/assets/icons/deactivate-icon.svg?react';
import OfflineIcon from '@/assets/icons/offline-icon.svg?react';
import ErrorIcon from '@/assets/icons/error-icon.svg?react';
import WarningIcon from '@/assets/icons/warning-icon.svg?react';
import BinFullIcon from '@/assets/icons/bin-full-icon.svg?react';
import { useTranslate } from 'react-admin';

export const useDeviceStates = () => {
    const translate = useTranslate();

    return [
        { id: 'online', name: translate('resources.device.choices.state.online'), icon: <ActiveIcon /> },
        { id: 'outOfService', name: translate('resources.device.choices.state.outOfService'), icon: <DisactiveIcon /> },
        { id: 'permanentError', name: translate('resources.device.choices.state.permanentError'), icon: <ErrorIcon />, tooltip: 'permanentError' },
        { id: 'binFull', name: translate('resources.device.choices.state.binFull'), icon: <BinFullIcon /> },
        { id: 'offline', name: translate('resources.device.choices.state.offline'), icon: <OfflineIcon /> },
        {
            id: 'codeError',
            name: translate('resources.device.choices.state.codeError'),
            icon: <WarningIcon />,
            tooltip: 'codeError',
        },
    ];
};
